import styled from "styled-components";

export const Container = styled.main`
  margin-top: 24px;

  position: relative;

  height: calc(100vh - 100px);

  h1 {
    color: var(--color-text-title);
    font-size: 28px;
    font-family: var(--font-title-bold);
  }

  @media (max-width: 405px) {
    nav {
      height: auto;

      & > div {
        flex-direction: column;
        margin-bottom: 10px;

        p,
        div {
          margin-bottom: 10px;
        }
      }
    }
  }
`;

export const SummarySection = styled.section`
  display: flex;
  justify-content: space-between;

  .buttons-container {
    display: flex;
    button {
      margin-left: 12px;
    }
  }

  & > div:not(.buttons-container) > *:nth-child(2) {
    color: var(--color-text-labels);
    font-family: var(--font-paragraph-default);
    font-size: 14px;
  }

  @media (max-width: 595px) {
    & > div > *:first-child {
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 10px;

      p {
        margin-left: 0;
        margin-top: 5px;
      }
    }
  }
`;

export const DetailsSection = styled.section`
  display: flex;
  gap: 14px;
  margin-top: 24px;
`;

export const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: min-content;
  gap: 32px;

  width: calc(100% - 320px);
  height: fit-content;

  border: 1px solid var(--color-light-200);
  border-radius: 8px;

  padding: 20px 16px;
  box-shadow: 0px 1px 3px 0px hsla(0, 0%, 56%, 0.15);
`;

export const DetailItem = styled.div`
  display: flex;
  flex-direction: column;

  height: fit-content;

  h3 {
    font-family: var(--font-title-bold);
    font-size: 16px;
    color: var(--color-text-title);
    margin-bottom: 16px;
  }

  span.value {
    font-family: var(--font-paragraph-default);
    font-size: 14px;
    color: var(--color-text-paragraph);
  }
`;
